const $ = jQuery.noConflict();

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign({}, this.getDefaultSlickSettings(), this.args);
	}

	init() {
		if (!$(this.selector).not('.slick-initialized').length) {
			return;
		}
		const settings = this.getSlickSettings();
		$(this.selector).slick(settings);

		// Set max-width to slider captions when variableWidth = true
		$(this.selector).on('setPosition', () => {
			$(this.selector)
				.find('figcaption')
				.each((i, item) => {
					const caption = $(item);
					const width = caption.closest('figure').find('img').width();
					caption.css('max-width', width > 0 ? `${width}px` : '');
				});
		});
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider');
const FluidSlider = new Slider(
	'.block-slider-gallery--hard .gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
	}
);
const FlexibleSlider = new Slider(
	'.block-slider-gallery--flexible .gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					arrows: false,
					centerMode: false,
				},
			},
		],
	}
);
export { SimpleSlider, TestimonialSlider, FluidSlider, FlexibleSlider };
